import { useCallback } from 'react';
import { useUI } from '../../contexts/UIProvider';
import { useGuideSlideshow } from './useGuideSlideshow';
import GuideSelectionPopup from './GuideSelectionPopup';
import GuideSlideshowPopup from './GuideSlideshowPopup';

interface GuideSlideshowButtonProps {
  guideCategory: 'seller' | 'buyer';
  guideSlug?: string;
  className?: string;
}

const GuideSlideshowButton = ({
  guideCategory,
  guideSlug,
  className = '',
}: GuideSlideshowButtonProps) => {
  const { setPopupContents, setPopupOpen } = useUI();
  const { fetchGuideData } = useGuideSlideshow(guideCategory, guideSlug);

  const handleClick = useCallback(async () => {
    const result = await fetchGuideData();
    if (!result) return;

    if (result.type === 'article') {
      setPopupContents(<GuideSlideshowPopup guide={result.guide} />);
    } else {
      setPopupContents(<GuideSelectionPopup guides={result.guides} category={guideCategory} />);
    }
    setPopupOpen(true);
  }, [fetchGuideData, guideCategory, setPopupContents, setPopupOpen]);

  return (
    <div
      onClick={handleClick}
      className={`guide-button ${className}`}
      data-testid="header-guide-btn"
      aria-label="Guide menu"
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 8.5a4 4 0 0 1 8 0c0 2.5-4 3-4 5.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="12" cy="18.5" r="1.4" fill="currentColor"/>
      </svg>
    </div>
  );
};

export default GuideSlideshowButton;
